<template>
	<v-card class="mb-4 caption">
		<v-card-text class="py-2">
			<div class="d-flex align-center justify-space-between">
				<div class="d-flex align-center">
					<p class="font-weight-bold body-2 px-1 mb-0">Pagos Realizados</p>
					<v-chip
						color="#524D4D"
						label
						outlined
						x-small
						class="ml-2"
					>
						<b>{{ payments.length }}</b>
					</v-chip>
				</div>
				<v-btn
					icon
					color="#524D4D"
					@click="showAll = !showAll"
				>
					<v-icon>{{showAll ? 'mdi-chevron-up':'mdi-chevron-down'}}</v-icon>
				</v-btn>
			</div>
			<div v-if="payments.length == 0" class="px-4 my-2">
				<p class="mb-0">Sin Pagos Registrados</p>
			</div>
			<div v-for="(payment, index) in final_payments" :key="'p-' + index">
				<div class="py-0 px-1 d-flex align-center justify-space-between">
					<div class="d-flex flex-column mx-1 mt-2" style="flex: 1 1 auto;">
						<p class="caption mb-1 justify-space-between d-flex">Fecha de pago: <b>{{ payment.payment_info?.created_at | toDateTime }}</b></p>
						<p class="caption mb-1 justify-space-between d-flex">Concepto: <b>{{payment.concept}}</b></p>
						<p class="caption mb-1 justify-space-between d-flex">Forma de Pago: <b>{{payment.payment_info?.method}}</b></p>
						<p class="caption mb-1 justify-space-between d-flex">Monto: <b>${{payment.payment_info?.amount | toThousandFilter}}</b></p>
					</div>
				</div>
				<v-divider class="my-1" v-show="index < (final_payments.length - 1)"></v-divider>
			</div>
		</v-card-text>
	</v-card>
</template>

<script>
export default {
	name: 'Payments',
	props: {
		preproject: {
			type: Object,
			required: true
		}
	},
  data() {
    return {
			showAll: false,
    };
  },
  computed: {
		final_payments(){
			if(this.showAll){
				return this.payments
			}
			return [this.payments[0]]
		},
		payments(){
			const reportPayments = this.preproject.report_budgets.flatMap(report => {
				const orders = report.budget?.payment_order || [];
				return orders.filter(order => order.payment_info);
			});

			reportPayments.sort((a, b) => new Date(a.payment_date) - new Date(b.payment_date))
			return reportPayments
		}
  },
	watch: {
	},
	mounted(){
	},
  methods: {
  },
};
</script>